/**
 * @module downloadChecklistPdf
 */

/**
 * Download Checklist PDF
 */

module.exports = function() {
    const printBtn = document.querySelector( '#pdf-btn' );

    const pageLink = printBtn.getAttribute( 'data-href' );
    const iframeId = 'print-pdf-iframe';

    initPrintOnClick();

    function initPrintOnClick() {
        printBtn.addEventListener( 'click', function( event ) {
            event.preventDefault();

            this.disabled = 'disabled';
            this.classList.add( 'loading' );

            initIframe();
        } );
    }

    function initIframe() {
        let iframe = document.getElementById( iframeId );

        if ( ! iframe ) {
            iframe = document.createElement( 'iframe' );
            iframe.id = iframeId;
            iframe.style.width = '100%';
            iframe.style.height = '1px';
            iframe.style.overflow = 'hidden';
            iframe.style.visibility = 'hidden';
            iframe.style.border = 'none';
            iframe.src = pageLink;
            // Wait for iframe to fully load before proceeding
            iframe.onload = function() {
                doPrintIframe( iframe );
            };
            // Append iframe to body
            document.body.appendChild( iframe );
        } else {
            // If iframe already exists, just print it
            doPrintIframe( iframe );
        }
    }
    function doPrintIframe( iframe ) {
        const iframeWindow = iframe.contentWindow;
        const iframeDoc = iframeWindow.document;

        iframeWindow.onafterprint = function() {
            printBtn.disabled = '';
            printBtn.classList.remove( 'loading' );
        };

        const checkReady = setInterval( () => {
            if ( iframeDoc.readyState === 'complete' ) {
                clearInterval( checkReady );

                // Hide feedback block
                const hkbFeedbackParent = iframeDoc.querySelector( '.hkb-feedback' ).parentElement;
                hkbFeedbackParent.classList.add( 'print-hidden' );

                // Find all article images
                const lazyImages = iframeDoc.querySelectorAll( '.hkb-entry-content img' ); // lite speed cache

                // Loop found images
                if ( lazyImages.length > 0 ) {
                    let loadedCount = 0;

                    lazyImages.forEach( ( img ) => {
                        // Check if image is lazy loaded
                        const actualSrc = img.getAttribute( 'data-src' );
                        if ( actualSrc ) {
                            img.src = actualSrc;
                            img.loading = 'eager';
                            img.srcset = '';
                        }

                        // Listen for the load event
                        if ( img.complete && img.naturalHeight !== 0 ) {
                            loadedCount++;
                        } else {
                            img.addEventListener( 'load', () => {
                                loadedCount++;
                                checkAllImagesLoaded();
                            } );

                            img.addEventListener( 'error', () => {
                                loadedCount++;
                                checkAllImagesLoaded();
                            } );
                        }
                    } );

                    // Initial check in case all images were already cached/loaded
                    checkAllImagesLoaded();

                    function checkAllImagesLoaded() {
                        if ( loadedCount === lazyImages.length ) {
                            delayAndPrint();
                        }
                    }
                } else {
                    // Print if no images in the article
                    delayAndPrint();
                }
            }
        }, 50 );

        function delayAndPrint() {
            setTimeout( function() {
                printBtn.disabled = '';
                printBtn.classList.remove( 'loading' );
                iframeWindow.focus();
                iframeWindow.print();
            }, 1000 );
        }
    }
};